import type { BffPhysicalDeviceResourceReadApi } from '@ingenico/api-sdk-provisioning-private';
import type { DeviceName } from '@ingenico/react-ui';
import { replace, toLower } from 'lodash-es';
import type { PhysicalDeviceInformation } from '../../domain/models/physicalDeviceInformation.model';

export function useTetraDeviceInfoCard({
  physicalDevice,
  attachedPhysicalDevice,
}: {
  readonly physicalDevice?: PhysicalDeviceInformation | null;
  readonly attachedPhysicalDevice?: BffPhysicalDeviceResourceReadApi | null;
}) {
  return {
    image: toLower(
      replace(
        physicalDevice?.deviceModel && physicalDevice?.deviceModel !== 'undefined'
          ? physicalDevice?.deviceModel
          : (attachedPhysicalDevice?.model ?? ''),
        /\//gu,
        '',
      ),
    ) as DeviceName,
    model:
      physicalDevice?.deviceModel && physicalDevice?.deviceModel !== 'undefined'
        ? physicalDevice?.deviceModel
        : attachedPhysicalDevice?.model,
    brand: physicalDevice?.deviceBrand,
    type: physicalDevice?.deviceType,
  };
}
